import { Box, Button, IconButton, Switch } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import SearchBar from "components/SearchBar";
import TableComponent from "components/TableComponent";
import MainContainer from "layout/MainContainer";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Listing } from "types/General";
import { isValidInput } from "utils/validations";

const ManageDiscount = () => {
  const navigate = useNavigate();
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [selectedId, setSelectedId] = useState("");
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(1);

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const columns: GridColDef[] = [
    {
      flex: 1,
      minWidth: 100,
      field: "name",
      headerName: "Discount Name",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{"FIRST001"}</p>
          </div>
        );
      },
    },

    {
      flex: 1,
      minWidth: 150,
      field: "type",
      filterable: false,
      sortable: false,
      headerName: "Type",
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{"Student"}</p>
          </div>
        );
      },
    },

    {
      flex: 1,
      minWidth: 150,
      field: "discount",
      filterable: false,
      sortable: false,
      headerName: "Discount",
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{"40%"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "startDate",
      filterable: false,
      sortable: false,
      headerName: "Start Date",
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{"10 jul, 2025"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "endDate",
      filterable: false,
      sortable: false,
      headerName: "End Date",
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{"20 jul, 2025"}</p>
          </div>
        );
      },
    },

    {
      flex: 1,
      minWidth: 150,
      field: "status",
      filterable: false,
      sortable: false,
      headerName: "Block/Unblock",
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={row?.isBlocked}
            // onChange={() => handleStatusUpdate(row?._id, !row?.isBlocked)}
          />
        );
      },
    },

    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: () => (
        <div className="table_actions v2">
          <Box>
            <IconButton onClick={() => navigate("/manage-discount/edit/1")}>
              <img src="/static/images/edit2_icon.svg" alt="" />
            </IconButton>
          </Box>
          <Box>
            <IconButton>
              <img src="/static/images/trash2_icon.svg" alt="" />
            </IconButton>
          </Box>
        </div>
      ),
    },
  ];

  const dummyListings: Listing[] = [
    {
      _id: "1",
      title: "Honda Civic 2020",
      vehicleType: 1,
      coverImage: "/static/images/vehicle_side.jpg",

      soldStatus: 0,
      image: [],
      isBlocked: false,
      status: 0,
      isPremiumCar: false,
    },
    {
      _id: "2",
      title: "Yamaha R15 V3",
      vehicleType: 1,
      coverImage: "/static/images/vehicle_side.jpg",

      soldStatus: 0,
      image: [],
      isBlocked: false,
      status: 0,
      isPremiumCar: false,
    },
    {
      _id: "3",
      title: "Tata 407 Mini Truck",
      vehicleType: 1,
      coverImage: "/static/images/vehicle_side.jpg",

      soldStatus: 0,
      image: [],
      isBlocked: false,
      status: 0,
      isPremiumCar: false,
    },
    {
      _id: "4",
      title: "Volvo FH16 Heavy Duty",
      vehicleType: 2,
      coverImage: "/static/images/vehicle_side.jpg",

      soldStatus: 0,
      image: [],
      isBlocked: false,
      status: 0,
      isPremiumCar: false,
    },
  ];

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Discounts</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Discounts
        </p>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button
                  className="btn btn_orange"
                  onClick={() => navigate("/manage-discount/add")}
                >
                  Add Discount
                </Button>
              </Box>
            </div>
          </div>

          <div className="sorting_table">
            <TableComponent
              columns={columns}
              rows={dummyListings}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
          </div>
        </Box>
      </div>
    </MainContainer>
  );
};

export default ManageDiscount;
